import LegalLayout, { Section } from './LegalLayout';

export default function PrivacyPage() {
  return (
    <LegalLayout title="Privacy Policy" subtitle="How we handle your data" updated="May 2026">
      <Section heading="What we store">
        Ashom stores your preferences (pinned tools, watchlist, portfolio holdings, settings) primarily
        in your browser's local storage. If you create an account, basic profile information and synced
        preferences are stored on our server.
      </Section>
      <Section heading="What we don't do">
        We do not sell your personal data. We do not place real trades or connect to your brokerage.
        Portfolio figures you enter are for tracking and education only.
      </Section>
      <Section heading="Third-party data">
        When the App fetches market data, requests are made to our server, which in turn retrieves data
        from third-party providers (see Data Sources). Those providers have their own privacy policies.
      </Section>
      <Section heading="Local data & clearing">
        You can clear locally-stored data at any time from your browser settings or by resetting
        progress within the App. Clearing local storage will remove pins, watchlist, and the
        disclaimer acknowledgment.
      </Section>
      <Section heading="Contact">
        For privacy questions, contact the platform administrator.
      </Section>
    </LegalLayout>
  );
}
